module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAQCAYAAACiEqkUAAABXUlEQVRYhc3XsUscQRTH8Y97h5jazloUNVhZChJBSK8RBD0sr0tjITZqJVjEQjsNQkD/AnuJbaqggpWdlQrpLBLQwr1jyO3CjqcyPxiYnfm99308dpnZnsdrZZrCcT5fwFmpE5s/NjrW1huda6kyspLgGg4wkI/v+dprKilGWSO+YDB4HsT8KxaYHKOoETWsFqyvobfr0hJl1PPxGeMYxgRGCxJ8xDl+4QoXOMG/CkUlz6jjEIsVQDCUj5aOKsYmz8gwVzG4SLMVfckzMvzsIsFpRV/yjAxLnr+TWP1Go6I3eUaGW0zjMiL4AjO4q+hPntE6Pm/RjEjQzGNilDQjvEfUIxJ8iPCGSo3R15qEjSg6c8s0EuENlRqj7Q0bMfZGsFCpMdrNDl+j/29vf/Atn39Ff7D3N6q092U8RDDa9YSN2MGk5x+TfWzhPt/bxQqWcYPtFxb5How9fIplPAHMgXE4vJXCLwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/3星.png
// module id = vYmK
// module chunks = 1